import { OreStack, OreStepper } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import {
  ChangeBankAccountStep1,
  ChangeBankAccountStep2,
  ChangeBankAccountStep3,
  ChangeBankAccountStep4,
} from '@/Contract/ui/molecules'
import { LogaltyResponseStatus } from '@/Logalty/domain'

const renderCurrentStep = (step: number): JSX.Element => {
  switch (step) {
    case 1:
      return <ChangeBankAccountStep1 />
    case 2:
      return <ChangeBankAccountStep2 />
    case 3:
      return <ChangeBankAccountStep3 />
    case 4:
      return <ChangeBankAccountStep4 />
    default:
      return <ChangeBankAccountStep1 />
  }
}

export const ChangeBankAccountStepper = (): JSX.Element => {
  const { t } = useTranslation()
  const {
    accountChangeStep,
    logalty: { signStatus },
  } = useBankAccount()

  return (
    <OreStack space="2xlarge" placeContent="stretch">
      <OreStepper
        activeStep={accountChangeStep}
        steps={[
          t(contractTranslation.changeBankAccount.stepper.step1),
          t(contractTranslation.changeBankAccount.stepper.step2),
          t(contractTranslation.changeBankAccount.stepper.step3),
          t(contractTranslation.changeBankAccount.stepper.step4),
        ]}
        errorStep={
          signStatus === LogaltyResponseStatus.Error ? accountChangeStep : undefined
        }
      />
      {renderCurrentStep(accountChangeStep)}
    </OreStack>
  )
}
